import { useAppContext } from '../contexts/AppContext'
import FomUploadService from '../services/fomService'

/**
 * Get an instance of the FomUploadService class configured using the app context.
 */
export default function useFomService() {
  const {
    config: { serviceAuthToken, fomServiceUrl },
  } = useAppContext()
  return new FomUploadService({
    baseUrl: `${fomServiceUrl}`,
    token: serviceAuthToken,
  })
}
